// extracted by mini-css-extract-plugin
module.exports = {"icon":"static-icon-circle_icon__3Dsz9"};